﻿import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from '../components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('../pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const ForgotPasswordPage = Loadable(lazy(() => import('../pages/auth/ForgotPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Navigate to="/login" replace />
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/register',
      element: <RegisterPage />
    }
    ,
    {
      path: '/forgot-password',
      element: <ForgotPasswordPage />
    }
    ,
    {
      path: '/reset-password',
      element: <ResetPasswordPage />
    }
  ]
};

export default LoginRoutes;

